import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCommentButtonComponent } from './fi-comment-button.component';
import { FiLikeButtonComponent } from './fi-like-button.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    imports: [CommonModule, MatIconModule, MatButtonModule, MatMenuModule],
    declarations: [FiCommentButtonComponent, FiLikeButtonComponent],
    exports: [FiCommentButtonComponent, FiLikeButtonComponent],
})
export class FiCommentLikeButtonsModule {}
